// Mint-Mov-Phone3 khung 1 "Bảng tin": dữ liệu mẫu + logic thuần (giữ trong bộ nhớ, không ghi DB).
export type NewsItem = { id: string; title: string; meta: string; read: boolean };

export const NEWS0: readonly NewsItem[] = [
  { id: 'n1', title: 'Từ 01/11 hạ hàng lạnh phải chụp màn hình máy lạnh lúc hạ', meta: 'Điều độ · 22/10', read: true },
  { id: 'n2', title: 'Báo cáo xe tháng 10 nộp trước 31/10 (8 hạng mục ảnh)', meta: 'Vận tải · 20/10', read: false },
  { id: 'n3', title: 'Cát Lái Giang Nam đổi cổng vào ca đêm sang cổng B', meta: 'Điều độ · 18/10', read: false },
  { id: 'n4', title: 'Lịch bảo dưỡng tháng 11: 50E13970 BD1 ngày 02/11', meta: 'Vận tải · 15/10', read: false },
];

export type LookupId = 'sop1' | 'sop2' | 'route' | 'video';
export const LOOKUPS: readonly { id: LookupId; title: string; sub: string; act: string }[] = [
  { id: 'sop1', title: 'Quy trình hạ cont lạnh', sub: 'SOP · 6 bước · ảnh bắt buộc', act: 'Mở' },
  { id: 'sop2', title: 'Quy trình cắt mooc tại kho', sub: 'SOP · khi nào dùng "Bỏ qua — cắt mooc"', act: 'Mở' },
  { id: 'route', title: 'Tra tuyến RRF0019', sub: 'CAT LAI TMNL → Kho Vinh Quang (Tiền Giang) · 83 km', act: 'Bản đồ' },
  { id: 'video', title: 'Video: chụp ảnh theo pha', sub: '2 phút · khung chụp, chống mờ', act: 'Xem' },
];

export const SOP = {
  title: 'Hạ cont lạnh · SOP',
  desc: 'Đọc trước khi vào cảng. Bản đầy đủ ở Đào tạo.',
  steps: [
    'Kiểm nhiệt độ máy lạnh trước khi rời kho.',
    'Chụp màn hình máy lạnh (nhiệt độ + vent).',
    'Vào cổng, đưa EIR, chờ hướng dẫn bãi.',
    'Lệch nhiệt độ > 2 °C: báo sự cố P0 ngay.',
    'Hạ cont, chụp EIR hạ.',
    'Bấm "Hạ cont" trên app.',
  ],
} as const;

export const unreadCount = (items: readonly NewsItem[], read: Readonly<Record<string, boolean>>) =>
  items.filter((n) => !n.read && !read[n.id]).length;
export const isRead = (n: NewsItem, read: Readonly<Record<string, boolean>>) => n.read || !!read[n.id];
export const refreshedAt = (fresh: boolean) => (fresh ? '09:42' : '09:31');
